import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  z-index: 10;
  inset: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(255 255 255 / 50%);
`;
